import { createAction } from 'redux-actions'

export const setServiceCategory = createAction('SERVICE_CATEGORY/SET_SERVICE_CATEGORY')
